// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bvxQs4U7KxCR5p {
  position: relative;
  min-height: 36px;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  scroll-margin: var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-0, 0);
}
.bvxQs4U7KxCR5p [data-smart-list-jira-card] {
  margin-bottom: var(--ds-space-100, 8px);
}
.OgAFa3akrdawbs {
  display: flex;
}
.sr3zJC5Ra_u42l {
  flex-grow: 1;
  margin-left: var(--ds-space-100, 8px);
}
.A9r5axOUuibAuA {
  display: flex;
  margin-top: var(--ds-space-200, 16px);
}
.CGDSRgJ6wWC27V {
  width: 50%;
  margin-left: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonWrapper": `bvxQs4U7KxCR5p`,
	"skeletonHeader": `OgAFa3akrdawbs`,
	"skeletonSummary": `sr3zJC5Ra_u42l`,
	"skeletonFooter": `A9r5axOUuibAuA`,
	"skeletonOpenPreview": `CGDSRgJ6wWC27V`
};
export default ___CSS_LOADER_EXPORT___;
